// Vendor libraries
import { createReducer, on } from '@ngrx/store';
// NgRx
import { setGenerateModalSelectedFolderableOperation } from 'CustomPDFReportsApp/ts/features/custom-pdf-report-modal/state/generate-modal-selected-folderable-operation/generate-modal-selected-folderable-operation.action';
export const GENERATE_MODAL_SELECTED_FOLDERABLE_OPERATION_SLICE_KEY = 'generateModalSelectedFolderableOperation';
/**
 * Reducer to save the generate modal folderable item and operation to perform on it.
 * This reducer supports selecting all folderable types.
 */
export const generateModalSelectedFolderableOperation = createReducer(null, on(setGenerateModalSelectedFolderableOperation, (_, action) => {
    return action.selectedOperation;
}));
